import {RootState} from '../rootReducer';

export const appInitializedSelector = (state: RootState): boolean => state.app.initialized;
export const appZoomSelector = (state: RootState) => state.app.zoom;
